import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import dashboardIcon from "../../Assets/Images/Revenue-management/dashboardIcon.svg";
import BI from "../../Assets/Images/Revenue-management/BI.svg";
import reload from "../../Assets/Images/Revenue-management/reloadIcon.svg";
import tools from "../../Assets/Images/Revenue-management/tools.svg";
import insight from "../../Assets/Images/Revenue-management/insight.svg";
import Accordion from "react-bootstrap/Accordion";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import RmInsight from "./RmInsight";
import { commonService } from "../../utils/commonService";
import bag from "../../Assets/Images/Configuration/bag.svg";
import infoIcon from "../../Assets/Images/Action Icons/infoIcon..svg";
import exportIcon from "../../Assets/Images/Email.svg";
import ViewSnapShotDetailModal from "./ViewSnapShotDetailModal";
import {
    errorToastMessage,
    successToastMessage,
} from "../../utils/toastMessage";
import { setAllDates } from "../../utils/slices/headerPropertySlice";

function AsideRevenueManagement() {
    const userDetail = commonService.getLoginUserData();
    const [menuList, setMenuList] = useState(null);
    const [asOfDate, setAsOfDate] = useState(null);
    const [showSnapShotDetailModal, setShowSnapShotDetailModal] = useState(false);
    const snapShotIdRef = useRef();
    const [loading, setLoading] = useState(false);
    const [propertyStatusList, setPropertyStatusList] = useState(null);
    const [selectedPropertyStatus, setSelectedPropertyStatus] = useState(null);
    const dispatch = useDispatch();
    let revPakIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.8 16.4H4.14C3.9682 16.8786 3.95411 17.3997 4.09979 17.8869C4.24547 18.3741 4.54327 18.8018 4.9496 19.1076C4.31095 19.3893 3.76784 19.8504 3.38624 20.4348C3.00465 21.0193 2.80099 21.702 2.8 22.4V23.2C2.8 23.4122 2.88428 23.6157 3.03431 23.7657C3.18434 23.9157 3.38782 24 3.6 24H20.4C20.6122 24 20.8157 23.9157 20.9657 23.7657C21.1157 23.6157 21.2 23.4122 21.2 23.2V22.4C21.2019 21.7014 20.9995 21.0175 20.6177 20.4325C20.2359 19.8474 19.6914 19.3868 19.0512 19.1072C19.4573 18.8013 19.7548 18.3736 19.9003 17.8865C20.0458 17.3994 20.0317 16.8785 19.86 16.4H21.2C21.6243 16.4 22.0313 16.2314 22.3314 15.9314C22.6314 15.6313 22.8 15.2243 22.8 14.8V2.4C22.8 1.97565 22.6314 1.56869 22.3314 1.26863C22.0313 0.968571 21.6243 0.8 21.2 0.8H19.6V0.4C19.6 0.293913 19.5579 0.192172 19.4828 0.117157C19.4078 0.0421427 19.3061 0 19.2 0C19.0939 0 18.9922 0.0421427 18.9172 0.117157C18.8421 0.192172 18.8 0.293913 18.8 0.4V0.8H16V0.4C16 0.293913 15.9579 0.192172 15.8828 0.117157C15.8078 0.0421427 15.7061 0 15.6 0C15.4939 0 15.3922 0.0421427 15.3172 0.117157C15.2421 0.192172 15.2 0.293913 15.2 0.4V0.8H12.4V0.4C12.4 0.293913 12.3579 0.192172 12.2828 0.117157C12.2078 0.0421427 12.1061 0 12 0C11.8939 0 11.7922 0.0421427 11.7172 0.117157C11.6421 0.192172 11.6 0.293913 11.6 0.4V0.8H8.8V0.4C8.8 0.293913 8.75785 0.192172 8.68284 0.117157C8.60783 0.0421427 8.50608 0 8.4 0C8.29391 0 8.19217 0.0421427 8.11715 0.117157C8.04214 0.192172 8 0.293913 8 0.4V0.8H5.2V0.4C5.2 0.293913 5.15785 0.192172 5.08284 0.117157C5.00783 0.0421427 4.90608 0 4.8 0C4.69391 0 4.59217 0.0421427 4.51715 0.117157C4.44214 0.192172 4.4 0.293913 4.4 0.4V0.8H2.8C2.37565 0.8 1.96868 0.968571 1.66863 1.26863C1.36857 1.56869 1.2 1.97565 1.2 2.4V14.8C1.2 15.2243 1.36857 15.6313 1.66863 15.9314C1.96868 16.2314 2.37565 16.4 2.8 16.4ZM4.8 17.2C4.8 16.8836 4.89384 16.5742 5.06965 16.3111C5.24546 16.048 5.49534 15.8429 5.7877 15.7218C6.08007 15.6007 6.40177 15.569 6.71214 15.6307C7.02251 15.6925 7.3076 15.8449 7.53137 16.0686C7.75513 16.2924 7.90752 16.5775 7.96925 16.8879C8.03099 17.1982 7.9993 17.5199 7.8782 17.8123C7.7571 18.1047 7.55203 18.3545 7.28891 18.5304C7.02579 18.7062 6.71645 18.8 6.4 18.8C5.97565 18.8 5.56868 18.6314 5.26863 18.3314C4.96857 18.0313 4.8 17.6243 4.8 17.2ZM16.1496 19.1076C15.8745 19.229 15.6157 19.3844 15.3792 19.57C15.2124 19.1145 14.9557 18.6971 14.6243 18.3428C14.293 17.9885 13.8938 17.7045 13.4504 17.5076C13.8221 17.2248 14.1034 16.84 14.26 16.4H15.34C15.1682 16.8786 15.1541 17.3997 15.2998 17.8869C15.4455 18.3741 15.7433 18.8018 16.1496 19.1076ZM9.2 23.2V20.8C9.2 20.0574 9.495 19.3452 10.0201 18.8201C10.5452 18.295 11.2574 18 12 18C12.7426 18 13.4548 18.295 13.9799 18.8201C14.505 19.3452 14.8 20.0574 14.8 20.8V23.2H9.2ZM12 17.2C11.6835 17.2 11.3742 17.1062 11.1111 16.9304C10.848 16.7545 10.6429 16.5047 10.5218 16.2123C10.4007 15.9199 10.369 15.5982 10.4307 15.2879C10.4925 14.9775 10.6449 14.6924 10.8686 14.4686C11.0924 14.2449 11.3775 14.0925 11.6879 14.0307C11.9982 13.969 12.3199 14.0007 12.6123 14.1218C12.9047 14.2429 13.1545 14.448 13.3303 14.7111C13.5062 14.9742 13.6 15.2836 13.6 15.6C13.6 16.0243 13.4314 16.4313 13.1314 16.7314C12.8313 17.0314 12.4243 17.2 12 17.2ZM10.5496 17.5076C10.1064 17.7043 9.70729 17.9881 9.37607 18.3422C9.04484 18.6963 8.78826 19.1135 8.6216 19.5688C8.38498 19.3835 8.12618 19.2285 7.8512 19.1072C8.25725 18.8013 8.5548 18.3736 8.70032 17.8865C8.84585 17.3994 8.83172 16.8785 8.66 16.4H9.74C9.89661 16.84 10.1779 17.2248 10.5496 17.5076ZM3.6 23.2V22.4C3.59948 21.8459 3.76339 21.3041 4.07097 20.8432C4.37856 20.3822 4.81598 20.023 5.32787 19.8108C5.83976 19.5986 6.40309 19.5431 6.94655 19.6513C7.49001 19.7594 7.98915 20.0264 8.3808 20.4184C8.3936 20.4312 8.4048 20.4452 8.4172 20.4584C8.4068 20.5708 8.4 20.6848 8.4 20.8V23.2H3.6ZM19.58 20.4176C19.8403 20.6779 20.0467 20.987 20.1874 21.3272C20.3281 21.6673 20.4003 22.0319 20.4 22.4V23.2H15.6V20.8C15.6 20.6864 15.5932 20.574 15.5828 20.4632C15.8402 20.1942 16.1487 19.9793 16.4903 19.8311C16.8318 19.6829 17.1995 19.6044 17.5718 19.6001C17.9441 19.5959 18.3135 19.666 18.6583 19.8064C19.0032 19.9468 19.3165 20.1546 19.58 20.4176ZM17.6 18.8C17.2835 18.8 16.9742 18.7062 16.7111 18.5304C16.448 18.3545 16.2429 18.1047 16.1218 17.8123C16.0007 17.5199 15.969 17.1982 16.0307 16.8879C16.0925 16.5775 16.2449 16.2924 16.4686 16.0686C16.6924 15.8449 16.9775 15.6925 17.2879 15.6307C17.5982 15.569 17.9199 15.6007 18.2123 15.7218C18.5047 15.8429 18.7545 16.048 18.9303 16.3111C19.1062 16.5742 19.2 16.8836 19.2 17.2C19.2 17.6243 19.0314 18.0313 18.7314 18.3314C18.4313 18.6314 18.0243 18.8 17.6 18.8ZM21.2 15.6H19.384C19.1599 15.3484 18.885 15.147 18.5776 15.0092C18.2701 14.8713 17.937 14.8 17.6 14.8C17.263 14.8 16.9299 14.8713 16.6224 15.0092C16.315 15.147 16.0401 15.3484 15.816 15.6H14.4C14.4 14.9635 14.1471 14.353 13.6971 13.9029C13.247 13.4529 12.6365 13.2 12 13.2C11.3635 13.2 10.753 13.4529 10.3029 13.9029C9.85285 14.353 9.6 14.9635 9.6 15.6H8.184C7.95986 15.3484 7.68504 15.147 7.37757 15.0092C7.07011 14.8713 6.73696 14.8 6.4 14.8C6.06304 14.8 5.72988 14.8713 5.42242 15.0092C5.11496 15.147 4.84013 15.3484 4.616 15.6H2.8C2.58782 15.6 2.38434 15.5157 2.23431 15.3657C2.08428 15.2157 2 15.0122 2 14.8V4H22V14.8C22 15.0122 21.9157 15.2157 21.7657 15.3657C21.6157 15.5157 21.4122 15.6 21.2 15.6ZM2.8 1.6H4.4V2C4.4 2.10609 4.44214 2.20783 4.51715 2.28284C4.59217 2.35786 4.69391 2.4 4.8 2.4C4.90608 2.4 5.00783 2.35786 5.08284 2.28284C5.15785 2.20783 5.2 2.10609 5.2 2V1.6H8V2C8 2.10609 8.04214 2.20783 8.11715 2.28284C8.19217 2.35786 8.29391 2.4 8.4 2.4C8.50608 2.4 8.60783 2.35786 8.68284 2.28284C8.75785 2.20783 8.8 2.10609 8.8 2V1.6H11.6V2C11.6 2.10609 11.6421 2.20783 11.7172 2.28284C11.7922 2.35786 11.8939 2.4 12 2.4C12.1061 2.4 12.2078 2.35786 12.2828 2.28284C12.3579 2.20783 12.4 2.10609 12.4 2V1.6H15.2V2C15.2 2.10609 15.2421 2.20783 15.3172 2.28284C15.3922 2.35786 15.4939 2.4 15.6 2.4C15.7061 2.4 15.8078 2.35786 15.8828 2.28284C15.9579 2.20783 16 2.10609 16 2V1.6H18.8V2C18.8 2.10609 18.8421 2.20783 18.9172 2.28284C18.9922 2.35786 19.0939 2.4 19.2 2.4C19.3061 2.4 19.4078 2.35786 19.4828 2.28284C19.5579 2.20783 19.6 2.10609 19.6 2V1.6H21.2C21.4122 1.6 21.6157 1.68429 21.7657 1.83431C21.9157 1.98434 22 2.18783 22 2.4V3.2H2V2.4C2 2.18783 2.08428 1.98434 2.23431 1.83431C2.38434 1.68429 2.58782 1.6 2.8 1.6Z" fill="black"></path>
      <path d="M14.8951 7.15055L13.56 6.79935L12.7059 5.56615C12.6267 5.45285 12.5214 5.36033 12.3988 5.29645C12.2762 5.23257 12.14 5.19922 12.0017 5.19922C11.8635 5.19922 11.7273 5.23257 11.6047 5.29645C11.4821 5.36033 11.3768 5.45285 11.2975 5.56615L10.4399 6.79935L9.10315 7.15095C8.94915 7.19044 8.80771 7.26842 8.69213 7.37757C8.57654 7.48672 8.49059 7.62346 8.44235 7.77495C8.39447 7.92366 8.38524 8.08211 8.41554 8.23537C8.44585 8.38863 8.51468 8.53165 8.61555 8.65095L9.46595 9.66695L9.39995 11.1238C9.39378 11.2607 9.42147 11.3971 9.48057 11.5208C9.53966 11.6445 9.62834 11.7517 9.73875 11.833C9.85183 11.9167 9.98384 11.9712 10.123 11.9916C10.2623 12.0121 10.4044 11.9978 10.5367 11.9502L11.9999 11.4262L13.4643 11.9502C13.5967 11.9977 13.7388 12.0119 13.878 11.9915C14.0172 11.971 14.1492 11.9166 14.2623 11.833C14.3727 11.7516 14.4613 11.6443 14.5202 11.5205C14.5791 11.3967 14.6065 11.2603 14.5999 11.1234L14.5311 9.66655L15.3811 8.65055C15.4821 8.53129 15.551 8.38829 15.5814 8.23503C15.6117 8.08177 15.6026 7.92329 15.5548 7.77455C15.5066 7.62321 15.4209 7.48656 15.3055 7.37742C15.1901 7.26828 15.0489 7.19022 14.8951 7.15055ZM14.7691 8.13735L13.8187 9.27295C13.7542 9.34986 13.7209 9.44824 13.7255 9.54855L13.7867 11.1886C13.7792 11.1939 13.7704 11.1973 13.7612 11.1986C13.752 11.1998 13.7427 11.1989 13.7339 11.1958L12.1339 10.6234C12.0468 10.5919 11.9515 10.5919 11.8643 10.6234L10.2643 11.1958C10.2407 11.2038 10.2223 11.1958 10.1959 11.1598L10.2723 9.54695C10.2768 9.44674 10.2437 9.34848 10.1795 9.27135L9.22875 8.13535C9.21428 8.11938 9.20438 8.09981 9.20009 8.0787C9.1958 8.05758 9.19727 8.0357 9.20435 8.01535C9.21171 7.99233 9.22501 7.97166 9.24293 7.95544C9.26084 7.93921 9.28272 7.928 9.30635 7.92295L10.7863 7.53335C10.8787 7.50869 10.9592 7.45197 11.0135 7.37335L11.9515 6.01815C11.9562 6.00991 11.9629 6.00305 11.9711 5.99827C11.9792 5.99349 11.9885 5.99098 11.9979 5.99098C12.0074 5.99098 12.0167 5.99349 12.0248 5.99827C12.033 6.00305 12.0397 6.00991 12.0443 6.01815L12.9827 7.37295C13.0368 7.45165 13.1173 7.5084 13.2095 7.53295L14.6895 7.92255C14.7132 7.92764 14.7351 7.93891 14.7531 7.95521C14.771 7.9715 14.7843 7.99226 14.7915 8.01535C14.7993 8.0358 14.8013 8.05797 14.7973 8.07947C14.7934 8.10097 14.7836 8.12099 14.7691 8.13735Z" fill="black"></path>
      <clipPath id="clip0_1930_40740"></clipPath>
    </svg>`;

    const closeSnapShotDetailModal = () => {
        setShowSnapShotDetailModal(false);
    };

    const propertyDetail = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const callSnapShotApi = useSelector(
        (store) => store.callApiAgain.snapShotApi
    );

    const allLastDates = useSelector((store) => store.headerProperty.allDates);

    const getAsideMenuList = async () => {
        let asideMenuListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.SNAPSHOT.GET_LIST_FOR_MENU,
                body: {
                    modulenames: "Revenue",
                    propertyid: propertyDetail?.propertyid
                        ? propertyDetail?.propertyid
                        : 0,
                },
            },
            false
        );

        let response = apiResponse(false, asideMenuListResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let groupingJson = {};
            for (let i = 0; i < dataFromApi?.length; i++) {
                if (groupingJson?.[dataFromApi?.[i]?.category]) {
                    groupingJson[dataFromApi[i].category] = [
                        ...groupingJson?.[dataFromApi?.[i]?.category],
                        dataFromApi?.[i],
                    ];
                } else {
                    groupingJson = {
                        ...groupingJson,
                        [dataFromApi?.[i]?.category]: [dataFromApi?.[i]],
                    };
                }
            }
            setMenuList(groupingJson);
            // setMenuList(response?.data?.data);
        }

        if (!response?.isValidate) {
            setMenuList(null);
        }
    };

    const getLastDateForAll = async () => {
        let lastDateResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.AS_OF_DATE.ALL_LAST_REFRESH_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        let response = apiResponse(false, lastDateResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let reservationDate = "",
                BiDate = "",
                rateshopDate = "",
                occDate = "";

            dataFromApi?.forEach((item) => {
                if (item?.processType === "CREATE_WIDGET") {
                    let utcDate = moment.utc(item?.updatedAt);
                    BiDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.processType === "REPORT_TO_UNI_RES") {
                    let utcDate = moment.utc(item?.updatedAt);
                    reservationDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.processType === "REPORT_TO_UNI_OCC") {
                    let utcDate = moment.utc(item?.updatedAt);
                    occDate = moment(utcDate).local().format("L hh:mm A");
                } else if (item?.jobType === "RATE_SHOP") {
                    let utcDate = moment.utc(item?.updatedAt);
                    rateshopDate = moment(utcDate).local().format("L hh:mm A");
                }
            });

            dispatch(
                setAllDates({
                    BiDate,
                    reservationDate,
                    rateshopDate,
                    occDate,
                })
            );
        }

        if (!response?.isValidate) {
        }
    };

    const getAsOfDate = async () => {
        let asOfDateResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        if (asOfDateResponse?.status_code === 0) {
            return errorToastMessage(asOfDateResponse?.message);
        } else if (asOfDateResponse?.status_code === 1) {
            setAsOfDate(
                asOfDateResponse?.data?.[0]?.last_data_refresh
                    ? asOfDateResponse?.data?.[0]?.last_data_refresh
                    : `${commonService.getDateForNode(new Date())} 00:00:00`
            );
        }
    };
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const fnsnapshotemailschedule = async () => {
        if (
            asOfDateFromRTK !== null &&
            asOfDateFromRTK !== "" &&
            propertyDetail !== null &&
            propertyDetail !== ""
        ) {
            let projectTermSaveResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.Configuration +
                        API_URL.SNAPSHOT.EMAIL_SCHEDULE_SAVE,
                    body: {
                        snapshotemailscheduleid: 0,
                        propertyid: propertyDetail.propertyid,
                        asofdate: asOfDateFromRTK,
                        category: "RevPAK",
                        baseurl: commonService.getItem("MD"),
                        snapshotid: 0,
                    },
                },
                true
            );

            let response = apiResponse(true, projectTermSaveResponse, setLoading);

            if (response?.isValidate) {
                setLoading(false);
                successToastMessage(response?.message);
            }
        } else {
            errorToastMessage("First Select Asofdate");
        }
    };

    const handlePropertyStatus = (list) => {
        if (propertyDetail?.propertycode) {
            let filterData = list?.filter(
                (x) => x?.propertyCode === propertyDetail?.propertycode
            );
            setSelectedPropertyStatus(filterData);
        }
    };

    const getPropertyStatus = async () => {
        let propertyStatusResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.CRM_SNAPSHOT.GET_PROPERTY_STATUS,
                body: {
                    clientid: userDetail?.clientid ? userDetail?.clientid : "",
                },
            },
            false
        );

        let response = apiResponse(false, propertyStatusResponse);

        if (response?.isValidate) {
            handlePropertyStatus(response?.data?.data);
            setPropertyStatusList(response?.data?.data);
        }

        if (!response?.isValidate) {
            setPropertyStatusList(null);
            setSelectedPropertyStatus(null);
        }
    };

    useEffect(() => {
        getPropertyStatus();
    }, [propertyDetail]);

    useEffect(() => {
        // if (propertyDetail) {
        getAsideMenuList();
        if (propertyDetail) {
            getAsOfDate();
            getLastDateForAll();
        }
        // }
    }, [propertyDetail, callSnapShotApi]);
    const [showModal, setShowModal] = useState(false);
    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);
    return (
        <>
            {commonService.checkUserRole("Revenue", "Dashboard", "isview") && (
                <aside
                    className={`revenue-management-aside-main asideConfigurationMain container-menu-bar`}
                >
                    <ul className="list-unstyled p-0 m-0">
                        <li>
                            <NavLink
                                to="/revenue/revenue-management-dashboard"
                                className="revenue-aside-links"
                            >
                                <img src={dashboardIcon} alt="dashboard" />
                                <span className="main-menu-text">Dashboard</span>
                            </NavLink>
                        </li>
                        <Accordion>
                            {menuList &&
                                Object?.entries(menuList)?.map(([key, value], index) => {
                                    if (key !== "Business Intelligence") {
                                        return (
                                            // <li key={value?.snapshotid}>
                                            <Accordion.Item
                                                eventKey={`${index}`}
                                                className="email-schedule-main"
                                            >
                                                <Accordion.Header className="configurationAccordionHeader  having-children">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: value?.[0]?.icon,
                                                        }}
                                                        style={{ marginRight: "13.5px" }}
                                                    ></div>
                                                    <span className="main-menu-text">{key}</span>
                                                </Accordion.Header>
                                                {key === "RevPAK" && (
                                                    <span
                                                        className="email-schedule-icon main-menu-text"
                                                        onClick={() => fnsnapshotemailschedule()}
                                                    >
                                                        <img src={exportIcon} alt="expotIcon" />
                                                    </span>
                                                )}
                                                <Accordion.Body>
                                                    <ul>
                                                        {value?.map((item, index) => {
                                                            return (
                                                                <>
                                                                    {key === "Reports" && index === 0 && (
                                                                        <li>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <NavLink
                                                                                    to={`/revenue/str-report`}
                                                                                    className="revenue-aside-links d-block"
                                                                                >
                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                        <div className="d-flex gap-3 align-items-center">
                                                                                            <div
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: revPakIcon,
                                                                                                }}
                                                                                            ></div>
                                                                                            <span>STR Reports</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </NavLink>
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                                    {item?.snapshottitle === "STR Analysis" ? (
                                                                        <li key={item?.snapshottitle}>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <NavLink
                                                                                    strAnalysis={`/revenue/snapshot/${item?.snapshottitle}/${item?.propertycode}/${item?.snapshotid}`}
                                                                                    to={`/revenue/snapshot/${item?.snapshottitle}/${item?.propertycode}/${item?.snapshotid}`}
                                                                                    className="revenue-aside-links d-block"
                                                                                >
                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                        <div className="d-flex gap-3 align-items-center">
                                                                                            <div
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: item?.icon,
                                                                                                }}
                                                                                            ></div>
                                                                                            <span>{item?.snapshottitle}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </NavLink>
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        snapShotIdRef.current =
                                                                                            item?.snapshotid;
                                                                                        setShowSnapShotDetailModal(true);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </li>
                                                                    ) : (
                                                                        <li key={item?.snapshottitle}>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <NavLink
                                                                                    to={`/revenue/snapshot/${item?.snapshottitle}/${item?.propertycode}/${item?.snapshotid}`}
                                                                                    className="revenue-aside-links d-block"
                                                                                >
                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                        <div className="d-flex gap-3 align-items-center">
                                                                                            <div
                                                                                                dangerouslySetInnerHTML={{
                                                                                                    __html: item?.icon,
                                                                                                }}
                                                                                            ></div>
                                                                                            <span>{item?.snapshottitle}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </NavLink>
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        snapShotIdRef.current =
                                                                                            item?.snapshotid;
                                                                                        setShowSnapShotDetailModal(true);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                        {key === "RevPAK" && (
                                                            <li>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <NavLink
                                                                        to={`/revenue/revpak-archive`}
                                                                        className="revenue-aside-links d-block"
                                                                    >
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div className="d-flex gap-3 align-items-center">
                                                                                <div
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: revPakIcon,
                                                                                    }}
                                                                                ></div>
                                                                                <span>RevPAK Archive</span>
                                                                            </div>
                                                                        </div>
                                                                    </NavLink>
                                                                </div>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            // </li>
                                        );
                                    }
                                })}
                            <Accordion.Item eventKey="101">
                                <Accordion.Header className="configurationAccordionHeader  having-children">
                                    <img src={BI} alt="tools" />
                                    <span className="main-menu-text">Business Intelligence</span>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <NavLink
                                                    to={`/revenue/business-intelligence`}
                                                    className="revenue-aside-links"
                                                >
                                                    <img src={tools} alt="configuration" />
                                                    <span>ALL</span>
                                                </NavLink>
                                            </div>
                                        </li>
                                        {menuList &&
                                            Object?.entries(menuList)?.map(([key, value], index) => {
                                                if (key === "Business Intelligence") {
                                                    return value?.map((item, index) => (
                                                        <li key={item?.snapshottitle}>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <NavLink
                                                                    to={`/revenue/snapshot/${item?.snapshottitle}/${item?.propertycode}/${item?.snapshotid}`}
                                                                    className="revenue-aside-links d-block"
                                                                >
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div className="d-flex gap-3 align-items-center">
                                                                            <div
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: item?.icon,
                                                                                }}
                                                                            ></div>
                                                                            <span>{item?.snapshottitle}</span>
                                                                        </div>
                                                                    </div>
                                                                </NavLink>
                                                                <img
                                                                    src={infoIcon}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        snapShotIdRef.current = item?.snapshotid;
                                                                        setShowSnapShotDetailModal(true);
                                                                    }}
                                                                />
                                                            </div>
                                                        </li>
                                                    ));
                                                }
                                            })}
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="102">
                                <Accordion.Header className="configurationAccordionHeader  having-children">
                                    <img src={bag} alt="tools" />
                                    <span className="main-menu-text">Tools</span>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <Accordion>
                                                <Accordion.Item
                                                    eventKey="1"
                                                    style={{ border: "none !important" }}
                                                    className="rateShopMenu"
                                                >
                                                    <Accordion.Header className="configurationAccordionHeader  having-children">
                                                        <span className="main-menu-text">Rate Shop</span>
                                                    </Accordion.Header>
                                                    <Accordion.Body className="rateShopAccrodian">
                                                        <ul>
                                                            <li>
                                                                <NavLink to="/revenue/rate-shop">
                                                                    Rate Shop
                                                                </NavLink>
                                                            </li>
                                                            <li>
                                                                <NavLink to="/revenue/rateIq">Rate IQ</NavLink>
                                                            </li>
                                                        </ul>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/bench-marking">
                                                Benchmarking
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/reminder">Reminder</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/event">Events</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/displacement-calculator">
                                                Displacement Calculator
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/perity-check">Parity Check</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/weather">Weather</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/flight">Flight Information</NavLink>
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="103">
                                <Accordion.Header className="configurationAccordionHeader  having-children">
                                    <img src={tools} alt="configuration" />
                                    <span className="main-menu-text">Setup</span>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li>
                                            <NavLink to="/revenue/role-management">
                                                Role Management
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/revenue/user-management">
                                                User Management
                                            </NavLink>
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        {/* <li>
              <Accordion>
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="configurationAccordionHeader  having-children">
                    <img src={BI} alt="tools" />
                    <span className="main-menu-text">
                      Business Intelligence
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>
                        <div className="d-flex justify-content-between align-items-center">
                          <NavLink
                            to={`/revenue/business-intelligence`}
                            className="revenue-aside-links"
                          >
                            <img src={tools} alt="configuration" />
                            <span>ALL</span>
                          </NavLink>
                        </div>
                      </li>
                      {menuList &&
                        Object?.entries(menuList)?.map(
                          ([key, value], index) => {
                            if (key === "Business Intelligence") {
                              return value?.map((item, index) => (
                                <li key={item?.snapshottitle}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <NavLink
                                      to={`/revenue/snapshot/${item?.snapshottitle}/${item?.propertycode}/${item?.snapshotid}`}
                                      className="revenue-aside-links d-block"
                                    >
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex gap-3 align-items-center">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: item?.icon,
                                            }}
                                          ></div>
                                          <span>{item?.snapshottitle}</span>
                                        </div>
                                      </div>
                                    </NavLink>
                                    <img
                                      src={infoIcon}
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        snapShotIdRef.current =
                                          item?.snapshotid;
                                        setShowSnapShotDetailModal(true);
                                      }}
                                    />
                                  </div>
                                </li>
                              ));
                            }
                          }
                        )}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li> */}

                        {/* <li>
              <Accordion>
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="configurationAccordionHeader  having-children">
                    <img src={bag} alt="tools" />
                    <span className="main-menu-text">Tools</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>
                        <Accordion>
                          <Accordion.Item
                            eventKey="1"
                            style={{ border: "none !important" }}
                            className="rateShopMenu"
                          >
                            <Accordion.Header className="configurationAccordionHeader  having-children">
                              <span className="main-menu-text">Rate Shop</span>
                            </Accordion.Header>
                            <Accordion.Body className="rateShopAccrodian">
                              <ul>
                                <li>
                                  <NavLink to="/revenue/rate-shop">
                                    Rate Shop
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink to="/revenue/rateIq">
                                    Rate IQ
                                  </NavLink>
                                </li>
                              </ul>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </li>
                      <li>
                        <NavLink to="/revenue/bench-marking">
                          Benchmarking
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/reminder">Reminder</NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/event">Events</NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/displacement-calculator">
                          Displacement Calculator
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/perity-check">
                          Parity Check
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/weather">Weather</NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/flight">
                          Flight Information
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li> */}
                        {/* <li>
              <Accordion>
                <Accordion.Item eventKey="1">
                  <Accordion.Header className="configurationAccordionHeader  having-children">
                    <img src={tools} alt="configuration" />
                    <span className="main-menu-text">Setup</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      <li>
                        <NavLink to="/revenue/role-management">
                          Role Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/revenue/user-management">
                          User Management
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li> */}
                        <li>
                            <NavLink
                                to="javascript:;"
                                onClick={openModal}
                                className="revenue-aside-links"
                            >
                                <img src={insight} alt="insight" />
                                <span className="main-menu-text">Insights</span>
                            </NavLink>
                        </li>
                        {/*<li>*/}
                        {/*    <div className="revenue-aside-links" onClick={openModal}>*/}
                        {/*        <img src={insight} alt="insight" />*/}
                        {/*        <span className="main-menu-text">Insight</span>*/}
                        {/*    </div>*/}
                        {/*</li>*/}
                        {propertyDetail && allLastDates && (
                            <li className="mt-4">
                                <span className="main-menu-text" style={{ fontWeight: "600" }}>
                                    Last Update Information
                                </span>
                            </li>
                        )}
                        {propertyDetail && allLastDates && (
                            <>
                                <li className="lastupdateinformation">
                                    <label
                                        className={`status ${selectedPropertyStatus?.[0]?.status.toLowerCase()}`}
                                    ></label>
                                    <b style={{ color: "#000" }}>Reservation :</b>{" "}
                                    {allLastDates?.reservationDate}{" "}
                                    <img
                                        style={{ height: "15px" }}
                                        src={reload}
                                        alt="dashboard"
                                    />
                                </li>
                                <li className="lastupdateinformation">
                                    <label
                                        className={`status ${selectedPropertyStatus?.[0]?.status.toLowerCase()}`}
                                    ></label>
                                    <b style={{ color: "#000" }}>Occupancy :</b> {allLastDates?.occDate}{" "}
                                    <img
                                        style={{ height: "15px" }}
                                        src={reload}
                                        alt="dashboard"
                                    />
                                </li>
                                <li className="lastupdateinformation">
                                    <label
                                        className={`status ${selectedPropertyStatus?.[0]?.status.toLowerCase()}`}
                                    ></label>
                                    <b style={{ color: "#000" }}>BI :</b> {allLastDates?.BiDate}{" "}
                                    <img
                                        style={{ height: "15px" }}
                                        src={reload}
                                        alt="dashboard"
                                    />
                                </li>
                            </>
                        )}
                    </ul>
                </aside>
            )}
            {showModal && <RmInsight show={showModal} handleClose={closeModal} />}

            {showSnapShotDetailModal && (
                <ViewSnapShotDetailModal
                    showModal={showSnapShotDetailModal}
                    closeModal={closeSnapShotDetailModal}
                    snapshotId={snapShotIdRef.current}
                />
            )}
        </>
    );
}

export default AsideRevenueManagement;
